import { __require as r } from "./index.es285.js";
var i = r();
export {
  i as j
};
//# sourceMappingURL=index.es52.js.map
